module.exports = __webpack_public_path__ + "img/logo1.1e7e1f6c.png";